{
  "Title": "Dettagli dell'attività ACD",
  "SectionTitleDatetimevalues": "VALORI DI DATA\/ORA",
  "SectionTitleDeviceandacdinfo": "INFORMAZIONI SUL DISPOSITIVO E SULL'ACD",
  "SectionTitleStatusvalues": "VALORI DI STATO",
  "SectionTitleAssociatedtelephonyenv": "AMBIENTE DI TELEFONIA ASSOCIATO",
  "SectionTitleDiagnosticvalues": "VALORI DIAGNOSTICI",
  "ButtonHelp": "Aiuto",
  "ButtonClose": "Chiudere",
  "ColumnHeaderValue": "Valore",
  "ColumnHeaderFieldStatistic": "Campo \/ Statistica",
  "ButtonCollapseall": "Chiudi tutti",
  "NAME": "ACDDNDActivity"
}